import {
	AT,
	BE,
	BG,
	CH,
	CN,
	CZ,
	DE,
	ES,
	FI,
	FR,
	HU,
	IL,
	IT,
	JP,
	KR,
	LT,
	MX,
	NL,
	NO,
	PL,
	SI,
	SK,
	TR,
	UA,
	US,
} from "country-flag-icons/string/3x2";
import { Country } from "../schema/Country.js";

export const countryEmojiMap: Record<Country, string> = {
	[Country.Czechia]: CZ,
	[Country.Poland]: PL,
	[Country.Germany]: DE,
	[Country.Slovakia]: SK,
	[Country.Ukraine]: UA,
	[Country.Italy]: IT,
	[Country.Belgium]: BE,
	[Country.France]: FR,
	[Country.Israel]: IL,
	[Country.Japan]: JP,
	[Country.Austria]: AT,
	[Country.Slovenia]: SI,
	[Country.Spain]: ES,
	[Country.Switzerland]: CH,
	[Country.Bulgaria]: BG,
	[Country.China]: CN,
	[Country.Finland]: FI,
	[Country.Korea]: KR, // South Korea assumed
	[Country.Lithuania]: LT,
	[Country.Hungary]: HU,
	[Country.Mexico]: MX,
	[Country.Norway]: NO,
	[Country.Netherlands]: NL,
	[Country.Turkey]: TR,
	[Country.USA]: US,
	// White flag for neutral competitors (Russia/Belarus, excluded from representing their country)
	[Country.Neutral]: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><rect x="5" y="5" width="503" height="332" fill="#fff" stroke="#cbd5e1" stroke-width="10"/></svg>`,
};
